var map = {
	"./decidim/avatar-multiuser.png": 96422,
	"./decidim/brands/facebook.svg": 90576,
	"./decidim/brands/google.svg": 97993,
	"./decidim/brands/twitter-x.svg": 23234,
	"./decidim/cc-badge.png": 70712,
	"./decidim/decidim-logo.svg": 4324,
	"./decidim/default-avatar.svg": 35708,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 22984,
	"./decidim/icons.svg": 39159,
	"./decidim/pattern.png": 57112,
	"./decidim/placeholder-card-g.svg": 94493,
	"./decidim/placeholder-card-l.svg": 42806,
	"./decidim/placeholder.jpg": 84181,
	"./decidim/remixicon.symbol.svg": 5497,
	"./decidim/vendor/social-share-button/douban.svg": 63000,
	"./decidim/vendor/social-share-button/email.svg": 83093,
	"./decidim/vendor/social-share-button/facebook.svg": 59755,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 23269,
	"./decidim/vendor/social-share-button/hacker_news.svg": 64453,
	"./decidim/vendor/social-share-button/linkedin.svg": 43597,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 63486,
	"./decidim/vendor/social-share-button/pinterest.svg": 60747,
	"./decidim/vendor/social-share-button/reddit.svg": 90207,
	"./decidim/vendor/social-share-button/telegram.svg": 17234,
	"./decidim/vendor/social-share-button/tumblr.svg": 3825,
	"./decidim/vendor/social-share-button/twitter.svg": 54916,
	"./decidim/vendor/social-share-button/vkontakte.svg": 35770,
	"./decidim/vendor/social-share-button/wechat.svg": 63685,
	"./decidim/vendor/social-share-button/whatsapp.svg": 70357,
	"./decidim/vendor/social-share-button/x.svg": 92437,
	"./decidim/vendor/social-share-button/xing.svg": 91499
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14279;